/**
 * `core/wordpress/mwwpform/index.js`
 * - MW WP Form プラグインが有効なときに動作
 *
 * 使用方法:
 * - import {initMwWpForm} from "../core/wordpress/mwwpform/index.js";
 */


import {config} from "../../../config.js";
import {mwwpformErrorHandler} from "./mwwpformErrorHandler.js";
import {mwwpformPrivacyCheck} from "./mwwpformPrivacyCheck.js";
import {mwwpformScriptLoader} from "./mwwpformScriptLoader.js";
import {initReCAPTCHA, loadReCaptcha} from "./recaptcha.js";
// import {manageBadgeReCAPTCHA} from "./recaptchaBadgeManager.js";  // router/common.jsに移動（別ページでの非表示監視が必要なため）


export function initMwWpForm(data) {
  console.log("📩 Initializing MW WP Form...");

  // 基本処理
  mwwpformErrorHandler();     // エラーハンドリング
  mwwpformPrivacyCheck();     // プライバシーポリシーチェック

  // barbaJS が有効ならロード
  if (config.useBarba) {
    mwwpformScriptLoader(); // MW WP Form JS をロード
  }

  // reCAPTCHA が有効ならロード
  if (config.recaptchaPublicKey) {
    loadReCaptcha();        // reCAPTCHA スクリプトのロード
    initReCAPTCHA();        // reCAPTCHA を適用
  }
}
